// extracted by mini-css-extract-plugin
module.exports = {"offersWrapper":"Offers-module--offersWrapper--2jasy","wrapper":"Offers-module--wrapper--3EKCy"};